import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { css } from 'styled-components';
//SDS
import Container from 'saur-design-sys-web/lib/Atoms/Container/Container';
import Word from 'saur-design-sys-web/lib/Atoms/Word/Word';
import Button from 'saur-design-sys-web/lib/Atoms/Input/Button/Button';
import Card from 'saur-design-sys-web/lib/Molecules/Card/Card';
import AppLogoV2 from 'saur-design-sys-web/lib/Atoms/AppLogo/AppLogoV2';
import { device } from 'saur-design-sys-web/lib/Theme';
import { getLanguage } from 'saur-viseau-state-management/lib/settings/selectors';
//SVSM
import { States } from 'saur-viseau-state-management/lib';
// internal
import ID_VALUES from '../automated-tests-ids/ids';

const AccessibilityScreen: FC = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const settingState = useSelector((state: States) => state.settings);
    const brandName = settingState?.params?.BrandFullName ?? 'Saur';
    const currentLang = useSelector(getLanguage) as string;
    const siteBaseUrl = window.location.origin;

    return (
        <Container className='accessibility-screen-wrapper'>
            <Container className='accessibility-header'>
                <AppLogoV2 logo={settingState?.params?.Logo} content='footer' />
            </Container>

            <Card className='accessibility-card'>
                <Container className='accessibility-screen-container'>

                    <Container className='back-button-wrapper'>
                        <Button
                            mode='basic'
                            className='back-button'
                            automatedTestId={ID_VALUES.accessibilityBackButton}
                            onClick={() => history.goBack()}
                        >
                            <Word
                                value={`← ${t('accessibility.closeButton')}`}
                                textStyle='normalBold'
                                variant='span'
                            />
                        </Button>
                    </Container>

                    <h1>{t('accessibility.pageTitle')}</h1>

                    <p>
                        Saur s'engage à rendre ses services internet « Déclaration en ligne des professionnels » accessible conformément à l'article 47 de la loi n° 2005-102 du 11 février 2005.
                    </p>
                    <p>À cette fin, elle met en œuvre la stratégie et les actions suivantes :</p>
                    <ul className='accessibility-list'>
                        <li>Schéma pluriannuel de mise en accessibilité 2026-2028 [en cours d'élaboration]</li>
                    </ul>
                    <p>
                        Cette déclaration d'accessibilité s'applique à{' '}
                        <a href={`${siteBaseUrl}/`} target='_blank' rel='noopener noreferrer'>{siteBaseUrl}/</a>
                    </p>

                    <h2>État de conformité</h2>
                    <p>
                        Le site Viseau,{' '}
                        <a href={`${siteBaseUrl}/`} target='_blank' rel='noopener noreferrer'>{siteBaseUrl}/</a>{' '}
                        est partiellement conforme avec le référentiel général d'amélioration de l'accessibilité (RGAA), version 4 en raison des non-conformités et des dérogations énumérées ci-dessous.
                    </p>

                    <h2>Résultats des tests</h2>
                    <p>
                        L'audit de conformité a été réalisé en auto évaluation avec l'outil d'évaluation d'accessibilité Fruggr (<a href='https://www.fruggr.io/fr/' target='_blank' rel='noopener noreferrer'>https://www.fruggr.io/fr/</a>) révèle que :
                    </p>
                    <ul className='accessibility-list'>
                        <li>65% des critères du RGAA version 4 sont respectés</li>
                        <li>Le taux moyen de conformité du service s'élève à 57%</li>
                    </ul>
                    <p>Détail des tests :</p>
                    <p>67 critères sont applicables sur 106 parmi lesquels :</p>
                    <ul className='accessibility-list'>
                        <li>44 critères conformes</li>
                        <li>23 critères non conformes</li>
                    </ul>

                    <h2>Contenus non accessibles</h2>
                    <p>Les contenus ci-dessous ne sont pas accessibles pour les raisons suivantes :</p>
                    <h3>Non conformités</h3>
                    <ul className='accessibility-list non-conformities'>
                        <li>Fournir une alternative textuelle à chaque image porteuse d'information</li>
                        <li>Marquer les images de décoration pour qu'elles soient ignorées par les technologies d'assistance</li>
                        <li>Associer correctement les légendes aux images concernées</li>
                        <li>Fournir un titre pertinent à chaque frame/iframe</li>
                        <li>Garantir un contraste suffisant entre texte et arrière-plan</li>
                        <li>Développer des scripts compatibles avec les technologies d'assistance</li>
                        <li>Éviter les changements de contexte imprévus. Prévenir l'utilisateur ou les rendre optionnels</li>
                        <li>Définir une langue par défaut pertinente</li>
                        <li>Fournir des titres de page pertinent</li>
                        <li>Structurer le contenu avec des titres hiérarchisés</li>
                        <li>Organiser l'information avec une structure cohérente et pertinente</li>
                        <li>Utiliser des balises de liste appropriées et cohérentes</li>
                        <li>Baliser correctement citations et extraits (blockquote, q, cite)</li>
                        <li>Assurer la lisibilité et l'accès au contenu sans CSS</li>
                        <li>Permettre de rendre l'information compréhensible même lorsque les feuilles de styles sont désactivées</li>
                        <li>Permettre le redimensionnement du texte sans perte de contenu ni fonctionnalité</li>
                        <li>Permettre aux utilisateurs de redéfinir les espacements</li>
                        <li>Rendre accessible les contenus visibles au survol ou au focus</li>
                        <li>Rendre déductible la finalité d'un champ de saisie</li>
                        <li>Fournir plusieurs moyens d'accès aux pages d'un même ensemble (sauf exceptions)</li>
                        <li>Maintenir un ordre de lecture et de navigation cohérent</li>
                        <li>Donner le contrôle à l'utilisateur sur chaque limite de temps</li>
                        <li>Prévenir l'utilisateur en cas de changement de contexte</li>
                    </ul>

                    <h3>Dérogations pour charge disproportionnée</h3>
                    <p>Aucun</p>

                    <h3>Contenus non soumis à l'obligation d'accessibilité</h3>
                    <p>Microsoft Power BI, ESRI ArcGIS Server, ESRI ArcGIS Enterprise</p>

                    <h2>Établissement de cette déclaration d'accessibilité</h2>
                    <p>Cette déclaration a été établie le 10/12/2025.</p>
                    <h3>
                        Technologies utilisées pour la réalisation de Viseau,{' '}
                        <a href={`${siteBaseUrl}/`} target='_blank' rel='noopener noreferrer'>{siteBaseUrl}/</a>
                    </h3>
                    <ul className='accessibility-list'>
                        <li>HTML5</li>
                        <li>CSS</li>
                        <li>React JS</li>
                    </ul>
                    <p>Les outils suivants ont été utilisés lors de l'évaluation :</p>
                    <ul className='accessibility-list'>
                        <li>
                            Fruggr{' '}
                            <a href='https://www.fruggr.io/fr/' target='_blank' rel='noopener noreferrer'>https://www.fruggr.io/fr/</a>
                        </li>
                        <li>Contrast Checker : Web Accessibility Color Contrast Checker - Conform to WCAG</li>
                    </ul>

                    <h3>Environnement de test</h3>
                    <p>
                        Les vérifications de restitution de contenus ont été réalisées sur la base de la combinaison fournie par la base de référence du RGAA, avec les versions suivantes :
                    </p>
                    <ul className='accessibility-list'>
                        <li>Firefox / internet explorer et NVDA</li>
                        <li>Safari et VoiceOver</li>
                    </ul>

                    <h2>Pages du site ayant fait l'objet de la vérification de conformité</h2>
                    <ul className='accessibility-list'>
                        <li>Page d'accueil : <a href={`${siteBaseUrl}/${currentLang}/connexion`} target='_blank' rel='noopener noreferrer'>{siteBaseUrl}/{currentLang}/connexion</a></li>
                        <li>Page documents : <a href={`${siteBaseUrl}/${currentLang}/documents`} target='_blank' rel='noopener noreferrer'>{siteBaseUrl}/{currentLang}/documents</a></li>
                        <li>Page tableau de bord : <a href={`${siteBaseUrl}/${currentLang}/dashboard`} target='_blank' rel='noopener noreferrer'>{siteBaseUrl}/{currentLang}/dashboard</a></li>
                        <li>Page Indicateurs : <a href={`${siteBaseUrl}/${currentLang}/reportings`} target='_blank' rel='noopener noreferrer'>{siteBaseUrl}/{currentLang}/reportings</a></li>
                        <li>Page sélection : <a href={`${siteBaseUrl}/${currentLang}/community-selection`} target='_blank' rel='noopener noreferrer'>{siteBaseUrl}/{currentLang}/community-selection</a></li>
                        <li>Page demandes : <a href={`${siteBaseUrl}/${currentLang}/requests`} target='_blank' rel='noopener noreferrer'>{siteBaseUrl}/{currentLang}/requests</a></li>
                        <li>Page Cartographie : <a href={`${siteBaseUrl}/${currentLang}/cartography`} target='_blank' rel='noopener noreferrer'>{siteBaseUrl}/{currentLang}/cartography</a></li>
                    </ul>

                    <h2>Retour d'information et contact</h2>
                    <p>
                        Si vous ne parvenez pas à accéder à un contenu ou à un service de Viseau en raison d'un défaut d'accessibilité sur :{' '}
                        <a href={`${siteBaseUrl}/`} target='_blank' rel='noopener noreferrer'>{siteBaseUrl}/</a>
                        , vous pouvez contacter votre interlocuteur habituel ou nous envoyer un courriel à l'adresse suivante :{' '}
                        <a href='mailto:viseauaccessibilite@saur.com'>viseauaccessibilite@saur.com</a>
                    </p>

                    <h2>Voies de recours</h2>
                    <p>
                        Si vous constatez un défaut d'accessibilité vous empêchant d'accéder à un contenu ou une fonctionnalité du site, que vous nous le signalez et que vous ne parvenez pas à obtenir une réponse de notre part, vous êtes en droit de faire parvenir vos doléances ou une demande de saisine au Défenseur des droits.
                    </p>
                    <p>Plusieurs moyens sont à votre disposition :</p>
                    <ul className='accessibility-list'>
                        <li>
                            <a href='https://formulaire.defenseurdesdroits.fr/' target='_blank' rel='noopener noreferrer'>
                                Écrire un message au Défenseur des droits
                            </a>
                        </li>
                        <li>
                            <a href='https://www.defenseurdesdroits.fr/fr/saisir/delegues' target='_blank' rel='noopener noreferrer'>
                                Contacter le délégué du Défenseur des droits dans votre région
                            </a>
                        </li>
                        <li>
                            Envoyer un courrier par la poste (gratuit, ne pas mettre de timbre) :<br />
                            Défenseur des droits<br />
                            Libre réponse 71120<br />
                            75342 Paris CEDEX 07
                        </li>
                    </ul>

                </Container>
            </Card>

            <Container className='accessibility-screen__footer'>
                <AppLogoV2 logo={settingState?.params?.Logo} content='footer' />
                <Word
                    value={t('cookiesConfig.banner.copyRight', { brandName })}
                    textStyle='xxsRegular'
                    variant='span'
                />
            </Container>
        </Container>
    );
};

export const AccessibilityScreenStyles = css`
    .accessibility-screen-wrapper {
        background-color: #f5f5f5;
        min-height: 100vh;
        padding: 40px 20px !important;
        display: flex;
        flex-direction: column;
        align-items: center;

        @media ${device.mobile} {
            padding: 20px 10px !important;
        }

        @media ${device.tablet} {
            padding: 40px 30px !important;
        }
    }

    .accessibility-header {
        max-width: 1000px;
        width: 100%;
        margin: 0 auto 30px auto;
        display: flex;
        justify-content: center;
        align-items: center;

        @media ${device.mobile} {
            margin-bottom: 20px;
        }
    }

    .accessibility-card {
        max-width: 1000px;
        width: 100%;
        margin: 0 auto;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        border-radius: 12px;
        overflow: hidden;

        @media ${device.mobile} {
            border-radius: 8px;
        }
    }

    .accessibility-screen-container {
        padding: 60px 50px;
        background-color: #ffffff;
        animation: fadeIn 0.6s ease-in;

        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to   { opacity: 1; transform: translateY(0); }
        }

        @media ${device.mobile} {
            padding: 30px 20px;
        }

        @media ${device.tablet} {
            padding: 50px 35px;
        }

        .back-button-wrapper {
            display: flex;
            justify-content: center;
            margin-bottom: 40px;

            @media ${device.mobile} {
                margin-bottom: 30px;
            }
        }

        .back-button {
            padding: 12px 30px;
            border-radius: 8px;
            transition: all 0.3s ease;
            background-color: #f5f5f5;
            border: 1px solid #e0e0e0;
            display: inline-flex;
            align-items: center;
            justify-content: center;

            &:hover {
                background-color: #e8f4f8;
                border-color: #0094FF;
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(0, 148, 255, 0.2);
            }

            span { color: #333; }
        }

        h1 {
            margin-bottom: 30px;
            padding-bottom: 20px;
            border-bottom: 3px solid #0094FF;
            color: #1a1a1a;
            text-align: center;

            @media ${device.mobile} {
                font-size: 22px;
                margin-bottom: 25px;
                padding-bottom: 15px;
            }
        }

        h2 {
            margin-top: 45px;
            margin-bottom: 20px;
            padding-left: 15px;
            border-left: 4px solid #0094FF;
            color: #2c3e50;

            @media ${device.mobile} {
                margin-top: 35px;
                font-size: 20px;
            }
        }

        h3 {
            margin-top: 30px;
            margin-bottom: 15px;
            color: #34495e;
            font-weight: 600;

            @media ${device.mobile} {
                margin-top: 25px;
                font-size: 18px;
            }
        }

        p {
            margin-bottom: 18px;
            line-height: 1.8;
            color: #444;
            text-align: justify;

            @media ${device.mobile} {
                line-height: 1.7;
                text-align: left;
            }
        }

        .accessibility-text {
            margin-bottom: 18px;
            line-height: 1.8;
            color: #444;
            text-align: justify;

            @media ${device.mobile} {
                line-height: 1.7;
                text-align: left;
            }
        }

        ul.accessibility-list {
            margin-bottom: 25px;
            background-color: #f9f9f9;
            padding: 20px 20px 20px 50px;
            border-radius: 8px;
            border-left: 3px solid #0094FF;
            list-style-type: disc;

            li {
                margin-bottom: 12px;
                line-height: 1.7;
                color: #555;

                &::marker {
                    color: #0094FF;
                    font-size: 1.2em;
                }
            }

            &.non-conformities {
                background-color: #fff5f5;
                border-left-color: #ff6b6b;

                li {
                    margin-bottom: 8px;
                    font-size: 14px;

                    &::marker { color: #ff6b6b; }
                }
            }

            @media ${device.mobile} {
                padding: 15px 15px 15px 40px;
            }
        }

        a {
            color: #0094FF;
            text-decoration: underline;
            word-break: break-all;
            transition: color 0.3s ease;

            &:hover { color: #0070cc; }
            &:focus {
                outline: 2px solid #0094FF;
                outline-offset: 2px;
            }
        }
    }

    .accessibility-screen__footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 1000px;
        width: 100%;
        margin: 30px auto 0 auto;
        padding: 0 20px;

        @media ${device.mobile} {
            flex-direction: column;
            padding: 12px 0 25px 0;
            align-items: center;
            gap: 8px;
            margin-top: 20px;
        }
    }
`;

export default AccessibilityScreen;
